import { Tab, Tabs } from "react-bootstrap";
import CompanyDashboard from "../../organisms/CompanyDashboard";
import Worklist from "../../organisms/Worklist";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Settlement from "../../organisms/Settlement";
import SettlementCount from "../../organisms/SettlementCount";
import AdminSettings from "../../organisms/AdminSettings";
import { useSelector } from "react-redux";
export default function Dashboard() {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeKey, setActiveKey] = useState("dashboard");
    const loginInfo = useSelector(state => state.login);

    useEffect(() => {
        // 초기 로드시 dashboard 탭으로 이동
        if (location.pathname === "/dashboard") {
            navigate("../dashboard", { replace: true });
        }
    }, []);

    return (
        <>
            <div className="page-title fw-bold">대시보드</div>
            <Tabs 
                activeKey={activeKey}
                onSelect={(activeKey) => {
                    setActiveKey(activeKey);
                }}
            >
                <Tab eventKey="dashboard" title="전체">
                    <CompanyDashboard/>
                </Tab>
                <Tab eventKey="worklist" title="워크리스트">
                    <Worklist/>
                </Tab>
                <Tab eventKey="settlement" title="피부측정">
                    <Settlement/>
                </Tab>
                {
                    loginInfo.isSuperAdmin && (
                        <Tab eventKey="settlementCount" title="정산">
                            <SettlementCount/>
                        </Tab>
                    )
                }
                {
                    loginInfo.isSuperAdmin && (
                        <Tab eventKey="adminSettings" title="싱크">
                            <AdminSettings/>
                        </Tab>
                    )
                }
   
            
            </Tabs>
        </>
    )
}